import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isStaff } from '../../lib/helper/authorisation';
import { consultantTicketSingleUpdate, consultantTicketSingleFetch } from '../../lib/redux/actions/consultantTickets';
import { consultantTicketTypeListFetch } from '../../lib/redux/actions/consultantTicketTypes';
import { addToast } from '../../lib/redux/actions/toast';
import CONSULTANT_TICKET_TYPE_CODES from '../../lib/helper/consultantTicketTypeCodes';
import MASpinner from '../common/MASpinner';

const mapStateToProps = (state) => ({
  ...state.consultantTickets,
  ...state.consultantTicketTypes,
});

const mapDispatchToProps = {
  consultantTicketSingleUpdate,
  consultantTicketSingleFetch,
  consultantTicketTypeListFetch,
  addToast,
};

class ReclassifyTicketTypeForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      selectedTypeIri: '',
      selectedTypeCode: null,
      typeOtherDetail: '',
      isSubmitting: false,
      error: null,
    };
  }

  componentDidMount() {
    this.props.consultantTicketTypeListFetch();
  }

  open() {
    this.setState({ isOpen: true, selectedTypeIri: '', selectedTypeCode: null, typeOtherDetail: '', error: null });
  }

  cancel() {
    this.setState({ isOpen: false, error: null });
  }

  handleTypeChange(e) {
    const { consultantTicketTypes = [] } = this.props;
    const selected = consultantTicketTypes.find((t) => t['@id'] === e.target.value);
    this.setState({ selectedTypeIri: e.target.value, selectedTypeCode: selected?.code ?? null, typeOtherDetail: '' });
  }

  handleSubmit() {
    const { consultantTicket, consultantTicketSingleUpdate, consultantTicketSingleFetch, addToast } = this.props;
    const { selectedTypeIri, selectedTypeCode, typeOtherDetail } = this.state;

    if (!selectedTypeIri) return;

    if (selectedTypeCode === CONSULTANT_TICKET_TYPE_CODES.OTHER && !typeOtherDetail.trim()) {
      this.setState({ error: 'Please specify details when selecting Other ticket type.' });
      return;
    }

    this.setState({ isSubmitting: true, error: null });

    consultantTicketSingleUpdate(
      {
        consultantTicketType: selectedTypeIri,
        typeOtherDetail: selectedTypeCode === CONSULTANT_TICKET_TYPE_CODES.OTHER ? typeOtherDetail.trim() : null,
      },
      consultantTicket.id,
    )
      .then(() => {
        consultantTicketSingleFetch(consultantTicket.id);
        addToast('Ticket type updated successfully', true);
        this.setState({ isOpen: false, isSubmitting: false });
      })
      .catch(() => {
        this.setState({ isSubmitting: false, error: 'Failed to update ticket type. Please try again.' });
      });
  }

  render() {
    const { consultantTicket, consultantTicketTypes = [] } = this.props;
    const { isOpen, selectedTypeIri, selectedTypeCode, typeOtherDetail, isSubmitting, error } = this.state;

    if (!isStaff() || consultantTicket.consultantTicketType.code === CONSULTANT_TICKET_TYPE_CODES.CONSULTANT_BROADCAST) {
      return null;
    }

    if (!isOpen) {
      return (
        <button type="button" className="btn btn-outline-secondary btn-xs ml-2" onClick={this.open.bind(this)}>
          <i className="fas fa-exchange-alt mr-1" />
          Reclassify
        </button>
      );
    }

    const options = [...consultantTicketTypes]
      .sort((a, b) => {
        if (a.code === CONSULTANT_TICKET_TYPE_CODES.OTHER) return 1;
        if (b.code === CONSULTANT_TICKET_TYPE_CODES.OTHER) return -1;
        return a.displayName.localeCompare(b.displayName);
      })
      .filter((t) => t['@id'] !== consultantTicket.consultantTicketType['@id']);

    return (
      <div className="mt-2 p-3 border rounded bg-light">
        <p className="mb-2">
          <strong>Reclassify Ticket Type</strong>
        </p>
        {error && <div className="alert alert-danger py-2">{error}</div>}
        <select
          className="form-control form-control-sm mb-2"
          value={selectedTypeIri}
          onChange={this.handleTypeChange.bind(this)}
          disabled={isSubmitting}>
          <option value="">Select new type...</option>
          {options.map((t) => (
            <option key={t['@id']} value={t['@id']}>
              {t.displayName}
            </option>
          ))}
        </select>
        {selectedTypeCode === CONSULTANT_TICKET_TYPE_CODES.OTHER && (
          <input
            type="text"
            className="form-control form-control-sm mb-2"
            placeholder="Please specify"
            value={typeOtherDetail}
            onChange={(e) => this.setState({ typeOtherDetail: e.target.value })}
            disabled={isSubmitting}
          />
        )}
        {isSubmitting ? (
          <MASpinner />
        ) : (
          <div>
            <button
              type="button"
              className="btn btn-primary btn-sm mr-2"
              disabled={!selectedTypeIri || (selectedTypeCode === CONSULTANT_TICKET_TYPE_CODES.OTHER && !typeOtherDetail.trim())}
              onClick={this.handleSubmit.bind(this)}>
              Save
            </button>
            <button type="button" className="btn btn-secondary btn-sm" onClick={this.cancel.bind(this)}>
              Cancel
            </button>
          </div>
        )}
      </div>
    );
  }
}

ReclassifyTicketTypeForm.propTypes = {
  consultantTicket: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReclassifyTicketTypeForm);
